export default {
  login: {
    login: 'Login',
    loginSubtitle: 'Sign in to your CMS account',
    username: 'Account',
    password: 'Password',
    forgetPassword: 'Forget Password?'
  },
  forgetPassword: {
    forgetPassword: 'Forget Password',
    forgetPasswordSubtitle: 'Enter your username to reset your password',
    username: 'Username',
    backToLogin: 'Back To Login',
    success: 'Your password has been reset. The new password has been sent to your registration email.'
  }
}



// WEBPACK FOOTER //
// ./src/Auth/langs/en_us/index.js